import React from 'react';
import { formatPossessive } from '@utils/commons';
import { statusOptions } from '@typings/ResidentTypes';

interface CareStatusProps {
  residentFullName: string;
  careStatus: string;
  setCareStatus: (status: string) => void;
  furtherCareStatus: string;
  setFurtherCareStatus: (infor: string) => void;
}

const CareStatus: React.FC<CareStatusProps> = ({
  residentFullName,
  careStatus,
  setCareStatus,
  furtherCareStatus,
  setFurtherCareStatus,
}) => {
  const handleChangeCareStatusOption = (e: any) => {
    const selectedStatus = e.target.value;
    setCareStatus(selectedStatus);
  };

  return (
    <div className="care-status mt-10 govuk-bp:mt-14">
      <div className="govuk-form-group">
        <fieldset className="govuk-fieldset">
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              What is {formatPossessive(residentFullName)} current care status?
            </h1>
          </legend>
          <div id="changedName-hint" className="govuk-hint">
            Please update the care status when circumstances change.
          </div>
          <div
            className="govuk-radios care-status__radios"
            data-module="govuk-radios"
          >
            {statusOptions.map(option => {
              return (
                <div className="govuk-radios__item" key={option.value}>
                  <input
                    className="govuk-radios__input"
                    id={option.value}
                    name={option.value}
                    type="radio"
                    value={option.value}
                    checked={careStatus === option.value}
                    onChange={handleChangeCareStatusOption}
                  />
                  <label
                    className="govuk-label govuk-radios__label"
                    htmlFor={option.value}
                  >
                    {option.label}
                  </label>
                </div>
              );
            })}
          </div>
        </fieldset>
      </div>

      <div className="govuk-form-group">
        <label className="govuk-label" htmlFor="further-care-status">
          Further Information can be added below
        </label>

        <textarea
          className="govuk-textarea"
          id="further-care-status"
          name="furtherCareStatus"
          rows={5}
          aria-describedby="more-detail-hint"
          placeholder="Enter additional details here..."
          value={furtherCareStatus}
          onChange={e => setFurtherCareStatus(e.target.value)}
        />
      </div>
    </div>
  );
};

export default CareStatus;
